
import React, { useState, useEffect } from 'react';
import { axiosInstance } from '../../../utils';
import { useParams } from "react-router-dom";

const MemberProfile = () => {
  const [data, setData] = useState(null);

  const { username } = useParams();
 
  useEffect(() => {
     getProfile();
  }, []);

    const token = localStorage?.getItem("token");
  

 const getProfile = async () => {
  try {
    await axiosInstance.post("/api/admin/view-member-profile", "",{
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {
        username: username
      }
    })
    .then(res =>  { setData(res.data?.data);
      
    })
    .catch(err => console.log(err))
  } catch (error) {
    console.log(error);
  }
 }

  return (
    <section className='container py-10'>
      <div className='p-4 bg-white rounded-lg min-h-max border-t-8 border-t-primary-yellow-500'>
        <p className='border-b-2 border-b-secondary-n-50 border-dashed pb-3 mb-6 font-poppins text-lg font-medium text-secondary-n-800'>Personal Information</p>
        <div className='grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-2 grid-cols-1 gap-6'>
          
            <div className='space-y-2'>
               <label htmlFor='username' className='font-poppins font-medium text-base text-secondary-n-500'>User Name:</label>
               <input type='text' value={data?.name}  className='border-b-2 border-b-secondary-n-50  w-full outline-none' readOnly />
            </div>
            <div className='space-y-2'>
               <label htmlFor='email' className='font-poppins font-medium text-base text-secondary-n-500'>Email:</label>
               <input type='email' value={data?.email} className='border-b-2 border-b-secondary-n-50  w-full outline-none' readOnly />
            </div>

            <div className='space-y-2'>
               <label htmlFor='passport' className='font-poppins font-medium text-base text-secondary-n-500'>Passport:</label>
               <input type='text' value={data?.passport}  className='border-b-2 border-b-secondary-n-50  w-full outline-none' readOnly />
            </div>   

            <div className='space-y-2'>
               <label htmlFor='contactNumber' className='font-poppins font-medium text-base text-secondary-n-500'>Contact Number:</label>
               <input type='tel' value={data?.phoneNumber} className='border-b-2 border-b-secondary-n-50  w-full outline-none' readOnly />
            </div>

            <div className='space-y-2'>
               <label htmlFor='status' className='font-poppins font-medium text-base text-secondary-n-500'>Status:</label>
               <div className='text-white bg-primary-green p-1 uppercase rounded-lg max-w-max'>{data?.verified ? "Active" : ""}</div>  
            </div>
          
        </div>
      </div>
    </section>
  )
}


export default MemberProfile;